import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
export class EventQuestData {
  get descriptor() {
    return EventQuestData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._eventQuests = [];
  }
  isEmpty() {
    if (this._eventQuests.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EventQuestData) {
      return value;
    }
    return EventQuestData.fromJson(value);
  }
  static fromJson(json) {
    const result = new EventQuestData();
    result._eventQuests = JsonToList(json.eventQuests, EventQuest);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._eventQuests.length > 0) {
      result.eventQuests = ArrayToJson(this._eventQuests, EventQuest);
    }
    return result;
  }
  /**
   * @returns {EventQuest[]}
   */
  get eventQuests() {
    return this._eventQuests;
  }
  addEventQuests(path, value) {
    return {type: 'ADD', path: path.concat(['eventQuests']), value: value.toJson()};
  }
  setEventQuests(path, value) {
    return {type: 'SET', path: path.concat(['eventQuests']), value: ArrayToJson(value, EventQuest)};
  }
  setEventQuestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['eventQuests', key]), value: value.toJson()};
  }
  deleteEventQuests(path) {
    return {type: 'DELETE', path: path.concat(['eventQuests'])};
  }
  deleteEventQuestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['eventQuests', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "eventQuests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuestData(this);
              copy._eventQuests = [];        for (let i of value) {
                copy._eventQuests.push(EventQuest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EventQuestData(this);
              copy._eventQuests = copy._eventQuests.concat([EventQuest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._eventQuests.length === 0) {
                return this;
              }
              const copy = new EventQuestData(this);
              copy._eventQuests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._eventQuests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EventQuestData(this);
              copy._eventQuests = copy._eventQuests.slice();
              copy._eventQuests[path[1]] = EventQuest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EventQuestData(this);
              copy._eventQuests = copy._eventQuests.slice(0, path[1]).concat(copy._eventQuests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._eventQuests.length) {
            return this;
          }
          const oldValue = this._eventQuests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EventQuestData(this);
          copy._eventQuests = copy._eventQuests.slice();
          copy._eventQuests[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EventQuestData} other
   * @returns {EventQuestData}
   */
  merge(other) {
    const copy = new EventQuestData(this);
    copy._eventQuests = this._eventQuests.concat(other._eventQuests);
    return copy;
  }
}
EventQuestData.default = new EventQuestData();
class EventQuestData_Builder {
  constructor(value) {
    this._value = new EventQuestData(value);
  }
  build() {
    return new EventQuestData(this._value);
  }
  addAllEventQuests(values) {
    this._value._eventQuests = this._value._eventQuests.concat(values);
    return this;
  }
  addEventQuests(value) {
    this._value._eventQuests = this._value._eventQuests.concat([value]);
    return this;
  }
  setEventQuests(index, value) {
    this._value._eventQuests = this._value._eventQuests.concat();
    this._value._eventQuests[index] = value;
    return this;
  }
  clearEventQuests() {
    this._value._eventQuests = [];
    return this;
  }
}
EventQuestData.Builder = EventQuestData_Builder;
class EventQuestData_WithParent {
  /**
   * @param {EventQuestData} value
   * @param {EventQuestData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EventQuestData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfEventQuests() {
    if (!this._selfEventQuests) {
      this._selfEventQuests = [];
      for (let i of this._value.eventQuests) {
        this._selfEventQuests.push(new EventQuest.WithParent(i, null));
      }
    }
    return this._selfEventQuests;
  }
  get inherentEventQuests() {
    if (!this._inherentEventQuests) {
      this._inherentEventQuests = this._parent ? this._parent.eventQuests : [];
    }
    return this._inherentEventQuests;
  }
  get eventQuests() {
    if (!this._allEventQuests) {
      this._allEventQuests = this._parent ? this._parent.eventQuests.concat(this.selfEventQuests) : this.selfEventQuests;
    }
    return this._allEventQuests;
  }
  update(current, parent) {
    const result = new EventQuestData_WithParent(current, parent);
    if (this._selfEventQuests) {
      if (this._value.eventQuests === current.eventQuests) {
        result._selfEventQuests = this._selfEventQuests;
      } else {
        result._selfEventQuests = [];
        for (let i = 0; i < current.eventQuests.length; i++) {
          const oldValue = this._value.eventQuests[i];
          if (oldValue) {
            const oldCache = this._selfEventQuests[i];
            if (oldValue === current.eventQuests[i]) {
              result._selfEventQuests[i] = oldCache;
            } else {
              result._selfEventQuests[i] = oldCache.update(current.eventQuests[i], null);
            }
          } else {
            result._selfEventQuests[i] = new EventQuest.WithParent(current.eventQuests[i], null);
          }
        }
      }
    }
    return result;
  }
}
EventQuestData_WithParent.default = new EventQuestData_WithParent(EventQuestData.default, null);
EventQuestData.WithParent = EventQuestData_WithParent;
class EventQuestData_Descriptor {
  get eventQuests() {
    if (!this._eventQuests) {
      this._eventQuests = {
        name: "eventQuests",
        Name: "EventQuests",
        number: 1,
        protoType: 11,
        protoName: "event_quests",
        type: EventQuest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventQuests;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.eventQuests,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
EventQuestData.descriptor = new EventQuestData_Descriptor();
class EventQuest_QuestPhase {
  get descriptor() {
    return EventQuest_QuestPhase.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCount = false;
    this._count = null;
    this._rewards = [];
  }
  isEmpty() {
    if (this._hasCount) return false;
    if (this._rewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EventQuest_QuestPhase) {
      return value;
    }
    return EventQuest_QuestPhase.fromJson(value);
  }
  static fromJson(json) {
    const result = new EventQuest_QuestPhase();
    if (json.count != null) {
      result._hasCount = true;
      result._count = JsonToInt32.fromJson(json.count);
    }
    result._rewards = JsonToList(json.rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCount) {
      result.count = JsonToInt32.toJson(this._count);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get count() {
    return this._hasCount ? this._count : JsonToInt32.default;
  }
  get hasCount() {
    return this._hasCount;
  }
  setCount(path, value) {
    return {type: 'SET', path: path.concat(['count']), value};
  }
  deleteCount(path) {
    return {type: 'DELETE', path: path.concat(['count'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "count": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest_QuestPhase(this);
              copy._hasCount = true;
              copy._count = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCount) {
                return this;
              }
              const copy = new EventQuest_QuestPhase(this);
              copy._hasCount = false;
              copy._count = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest_QuestPhase(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EventQuest_QuestPhase(this);
              copy._rewards = copy._rewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new EventQuest_QuestPhase(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EventQuest_QuestPhase(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EventQuest_QuestPhase(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EventQuest_QuestPhase(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EventQuest_QuestPhase} other
   * @returns {EventQuest_QuestPhase}
   */
  merge(other) {
    const copy = new EventQuest_QuestPhase(this);
    if (other._hasCount) {
      copy._hasCount = true;
      copy._count = other._count;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    return copy;
  }
}
EventQuest_QuestPhase.default = new EventQuest_QuestPhase();
class EventQuest_QuestPhase_Builder {
  constructor(value) {
    this._value = new EventQuest_QuestPhase(value);
  }
  build() {
    return new EventQuest_QuestPhase(this._value);
  }
  setCount(value) {
    this._value._hasCount = true;
    this._value._count = value;
    return this;
  }
  deleteCount() {
    this._value._hasCount = false;
    this._value._count = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
}
EventQuest_QuestPhase.Builder = EventQuest_QuestPhase_Builder;
class EventQuest_QuestPhase_WithParent {
  /**
   * @param {EventQuest_QuestPhase} value
   * @param {EventQuest_QuestPhase_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EventQuest_QuestPhase.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCount() {
    if (this._cachedHasCount === undefined) {
      if (this._value.hasCount) {
        this._cachedHasCount = true;
      } else {
        this._cachedHasCount = this._parent ? this._parent.hasCount : false;
      }
    }
    return this._cachedHasCount;
  }
  get count() {
    if (this._cachedCount === undefined) {
      if (this._value.hasCount) {
        this._cachedCount = this._value.count;
      } else {
        this._cachedCount = this._parent ? this._parent.count : this._value.count;
      }
    }
    return this._cachedCount;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  update(current, parent) {
    const result = new EventQuest_QuestPhase_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
EventQuest_QuestPhase_WithParent.default = new EventQuest_QuestPhase_WithParent(EventQuest_QuestPhase.default, null);
EventQuest_QuestPhase.WithParent = EventQuest_QuestPhase_WithParent;
class EventQuest_QuestPhase_Descriptor {
  get count() {
    if (!this._count) {
      this._count = {
        name: "count",
        Name: "Count",
        number: 1,
        protoType: 5,
        protoName: "count",
        type: JsonToInt32,
        options: {
          comments: "Target count to unlock current event quest phase\'s rewards",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._count;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 2,
        protoType: 11,
        protoName: "rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.count,
        this.rewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCount",
        Name: "DummyOneofForCount",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
EventQuest_QuestPhase.descriptor = new EventQuest_QuestPhase_Descriptor();
export class EventQuest {
  get descriptor() {
    return EventQuest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasName = false;
    this._name = null;
    this._phases = [];
    this._hasStartTime = false;
    this._startTime = null;
    this._hasDurationInHours = false;
    this._durationInHours = null;
    this._hasDescription = false;
    this._description = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasName) return false;
    if (this._phases.length > 0) return false;
    if (this._hasStartTime) return false;
    if (this._hasDurationInHours) return false;
    if (this._hasDescription) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EventQuest) {
      return value;
    }
    return EventQuest.fromJson(value);
  }
  static fromJson(json) {
    const result = new EventQuest();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    result._phases = JsonToList(json.phases, EventQuest_QuestPhase);
    if (json.startTime != null) {
      result._hasStartTime = true;
      result._startTime = JsonToInt32.fromJson(json.startTime);
    }
    if (json.durationInHours != null) {
      result._hasDurationInHours = true;
      result._durationInHours = JsonToInt32.fromJson(json.durationInHours);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._phases.length > 0) {
      result.phases = ArrayToJson(this._phases, EventQuest_QuestPhase);
    }
    if (this._hasStartTime) {
      result.startTime = JsonToInt32.toJson(this._startTime);
    }
    if (this._hasDurationInHours) {
      result.durationInHours = JsonToInt32.toJson(this._durationInHours);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {EventQuest_QuestPhase[]}
   */
  get phases() {
    return this._phases;
  }
  addPhases(path, value) {
    return {type: 'ADD', path: path.concat(['phases']), value: value.toJson()};
  }
  setPhases(path, value) {
    return {type: 'SET', path: path.concat(['phases']), value: ArrayToJson(value, EventQuest_QuestPhase)};
  }
  setPhasesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['phases', key]), value: value.toJson()};
  }
  deletePhases(path) {
    return {type: 'DELETE', path: path.concat(['phases'])};
  }
  deletePhasesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['phases', key])};
  }
  /**
   * @returns {number}
   */
  get startTime() {
    return this._hasStartTime ? this._startTime : JsonToInt32.default;
  }
  get hasStartTime() {
    return this._hasStartTime;
  }
  setStartTime(path, value) {
    return {type: 'SET', path: path.concat(['startTime']), value};
  }
  deleteStartTime(path) {
    return {type: 'DELETE', path: path.concat(['startTime'])};
  }
  /**
   * @returns {number}
   */
  get durationInHours() {
    return this._hasDurationInHours ? this._durationInHours : JsonToInt32.default;
  }
  get hasDurationInHours() {
    return this._hasDurationInHours;
  }
  setDurationInHours(path, value) {
    return {type: 'SET', path: path.concat(['durationInHours']), value};
  }
  deleteDurationInHours(path) {
    return {type: 'DELETE', path: path.concat(['durationInHours'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new EventQuest(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new EventQuest(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "phases": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._phases = [];        for (let i of value) {
                copy._phases.push(EventQuest_QuestPhase.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new EventQuest(this);
              copy._phases = copy._phases.concat([EventQuest_QuestPhase.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._phases.length === 0) {
                return this;
              }
              const copy = new EventQuest(this);
              copy._phases = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._phases.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._phases = copy._phases.slice();
              copy._phases[path[1]] = EventQuest_QuestPhase.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new EventQuest(this);
              copy._phases = copy._phases.slice(0, path[1]).concat(copy._phases.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._phases.length) {
            return this;
          }
          const oldValue = this._phases[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new EventQuest(this);
          copy._phases = copy._phases.slice();
          copy._phases[key] = newValue;
          return copy;
        }
      }
      case "startTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._hasStartTime = true;
              copy._startTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartTime) {
                return this;
              }
              const copy = new EventQuest(this);
              copy._hasStartTime = false;
              copy._startTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "durationInHours": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._hasDurationInHours = true;
              copy._durationInHours = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDurationInHours) {
                return this;
              }
              const copy = new EventQuest(this);
              copy._hasDurationInHours = false;
              copy._durationInHours = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuest(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new EventQuest(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EventQuest} other
   * @returns {EventQuest}
   */
  merge(other) {
    const copy = new EventQuest(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    copy._phases = this._phases.concat(other._phases);
    if (other._hasStartTime) {
      copy._hasStartTime = true;
      copy._startTime = other._startTime;
    }
    if (other._hasDurationInHours) {
      copy._hasDurationInHours = true;
      copy._durationInHours = other._durationInHours;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    return copy;
  }
}
EventQuest.default = new EventQuest();
EventQuest.QuestPhase = EventQuest_QuestPhase;
class EventQuest_Builder {
  constructor(value) {
    this._value = new EventQuest(value);
  }
  build() {
    return new EventQuest(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  addAllPhases(values) {
    this._value._phases = this._value._phases.concat(values);
    return this;
  }
  addPhases(value) {
    this._value._phases = this._value._phases.concat([value]);
    return this;
  }
  setPhases(index, value) {
    this._value._phases = this._value._phases.concat();
    this._value._phases[index] = value;
    return this;
  }
  clearPhases() {
    this._value._phases = [];
    return this;
  }
  setStartTime(value) {
    this._value._hasStartTime = true;
    this._value._startTime = value;
    return this;
  }
  deleteStartTime() {
    this._value._hasStartTime = false;
    this._value._startTime = null;
    return this;
  }
  setDurationInHours(value) {
    this._value._hasDurationInHours = true;
    this._value._durationInHours = value;
    return this;
  }
  deleteDurationInHours() {
    this._value._hasDurationInHours = false;
    this._value._durationInHours = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
}
EventQuest.Builder = EventQuest_Builder;
class EventQuest_WithParent {
  /**
   * @param {EventQuest} value
   * @param {EventQuest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EventQuest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get selfPhases() {
    if (!this._selfPhases) {
      this._selfPhases = [];
      for (let i of this._value.phases) {
        this._selfPhases.push(new EventQuest_QuestPhase.WithParent(i, null));
      }
    }
    return this._selfPhases;
  }
  get inherentPhases() {
    if (!this._inherentPhases) {
      this._inherentPhases = this._parent ? this._parent.phases : [];
    }
    return this._inherentPhases;
  }
  get phases() {
    if (!this._allPhases) {
      this._allPhases = this._parent ? this._parent.phases.concat(this.selfPhases) : this.selfPhases;
    }
    return this._allPhases;
  }
  get hasStartTime() {
    if (this._cachedHasStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedHasStartTime = true;
      } else {
        this._cachedHasStartTime = this._parent ? this._parent.hasStartTime : false;
      }
    }
    return this._cachedHasStartTime;
  }
  get startTime() {
    if (this._cachedStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedStartTime = this._value.startTime;
      } else {
        this._cachedStartTime = this._parent ? this._parent.startTime : this._value.startTime;
      }
    }
    return this._cachedStartTime;
  }
  get hasDurationInHours() {
    if (this._cachedHasDurationInHours === undefined) {
      if (this._value.hasDurationInHours) {
        this._cachedHasDurationInHours = true;
      } else {
        this._cachedHasDurationInHours = this._parent ? this._parent.hasDurationInHours : false;
      }
    }
    return this._cachedHasDurationInHours;
  }
  get durationInHours() {
    if (this._cachedDurationInHours === undefined) {
      if (this._value.hasDurationInHours) {
        this._cachedDurationInHours = this._value.durationInHours;
      } else {
        this._cachedDurationInHours = this._parent ? this._parent.durationInHours : this._value.durationInHours;
      }
    }
    return this._cachedDurationInHours;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  update(current, parent) {
    const result = new EventQuest_WithParent(current, parent);
    if (this._selfPhases) {
      if (this._value.phases === current.phases) {
        result._selfPhases = this._selfPhases;
      } else {
        result._selfPhases = [];
        for (let i = 0; i < current.phases.length; i++) {
          const oldValue = this._value.phases[i];
          if (oldValue) {
            const oldCache = this._selfPhases[i];
            if (oldValue === current.phases[i]) {
              result._selfPhases[i] = oldCache;
            } else {
              result._selfPhases[i] = oldCache.update(current.phases[i], null);
            }
          } else {
            result._selfPhases[i] = new EventQuest_QuestPhase.WithParent(current.phases[i], null);
          }
        }
      }
    }
    return result;
  }
}
EventQuest_WithParent.default = new EventQuest_WithParent(EventQuest.default, null);
EventQuest.WithParent = EventQuest_WithParent;
class EventQuest_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          comments: "Every event quest has it\'s unique key",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 2,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "Path to the event quest title ui",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get phases() {
    if (!this._phases) {
      this._phases = {
        name: "phases",
        Name: "Phases",
        number: 3,
        protoType: 11,
        protoName: "phases",
        type: EventQuest_QuestPhase,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._phases;
  }
  get startTime() {
    if (!this._startTime) {
      this._startTime = {
        name: "startTime",
        Name: "StartTime",
        number: 4,
        protoType: 5,
        protoName: "start_time",
        type: JsonToInt32,
        options: {
          comments: "Event quest start time timestamp",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startTime;
  }
  get durationInHours() {
    if (!this._durationInHours) {
      this._durationInHours = {
        name: "durationInHours",
        Name: "DurationInHours",
        number: 5,
        protoType: 5,
        protoName: "duration_in_hours",
        type: JsonToInt32,
        options: {
          comments: "Event quest duration in hours",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._durationInHours;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 6,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          comments: "Path to the event quest description ui",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.name,
        this.phases,
        this.startTime,
        this.durationInHours,
        this.description,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartTime",
        Name: "DummyOneofForStartTime",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDurationInHours",
        Name: "DummyOneofForDurationInHours",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
EventQuest.descriptor = new EventQuest_Descriptor();
export class EventQuestStatus {
  get descriptor() {
    return EventQuestStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasCurrentCount = false;
    this._currentCount = null;
    this._hasClaimPhase = false;
    this._claimPhase = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasCurrentCount) return false;
    if (this._hasClaimPhase) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EventQuestStatus) {
      return value;
    }
    return EventQuestStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new EventQuestStatus();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.currentCount != null) {
      result._hasCurrentCount = true;
      result._currentCount = JsonToInt32.fromJson(json.currentCount);
    }
    if (json.claimPhase != null) {
      result._hasClaimPhase = true;
      result._claimPhase = JsonToInt32.fromJson(json.claimPhase);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasCurrentCount) {
      result.currentCount = JsonToInt32.toJson(this._currentCount);
    }
    if (this._hasClaimPhase) {
      result.claimPhase = JsonToInt32.toJson(this._claimPhase);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get currentCount() {
    return this._hasCurrentCount ? this._currentCount : JsonToInt32.default;
  }
  get hasCurrentCount() {
    return this._hasCurrentCount;
  }
  setCurrentCount(path, value) {
    return {type: 'SET', path: path.concat(['currentCount']), value};
  }
  deleteCurrentCount(path) {
    return {type: 'DELETE', path: path.concat(['currentCount'])};
  }
  /**
   * @returns {number}
   */
  get claimPhase() {
    return this._hasClaimPhase ? this._claimPhase : JsonToInt32.default;
  }
  get hasClaimPhase() {
    return this._hasClaimPhase;
  }
  setClaimPhase(path, value) {
    return {type: 'SET', path: path.concat(['claimPhase']), value};
  }
  deleteClaimPhase(path) {
    return {type: 'DELETE', path: path.concat(['claimPhase'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuestStatus(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new EventQuestStatus(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuestStatus(this);
              copy._hasCurrentCount = true;
              copy._currentCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentCount) {
                return this;
              }
              const copy = new EventQuestStatus(this);
              copy._hasCurrentCount = false;
              copy._currentCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "claimPhase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EventQuestStatus(this);
              copy._hasClaimPhase = true;
              copy._claimPhase = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClaimPhase) {
                return this;
              }
              const copy = new EventQuestStatus(this);
              copy._hasClaimPhase = false;
              copy._claimPhase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EventQuestStatus} other
   * @returns {EventQuestStatus}
   */
  merge(other) {
    const copy = new EventQuestStatus(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasCurrentCount) {
      copy._hasCurrentCount = true;
      copy._currentCount = other._currentCount;
    }
    if (other._hasClaimPhase) {
      copy._hasClaimPhase = true;
      copy._claimPhase = other._claimPhase;
    }
    return copy;
  }
}
EventQuestStatus.default = new EventQuestStatus();
class EventQuestStatus_Builder {
  constructor(value) {
    this._value = new EventQuestStatus(value);
  }
  build() {
    return new EventQuestStatus(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setCurrentCount(value) {
    this._value._hasCurrentCount = true;
    this._value._currentCount = value;
    return this;
  }
  deleteCurrentCount() {
    this._value._hasCurrentCount = false;
    this._value._currentCount = null;
    return this;
  }
  setClaimPhase(value) {
    this._value._hasClaimPhase = true;
    this._value._claimPhase = value;
    return this;
  }
  deleteClaimPhase() {
    this._value._hasClaimPhase = false;
    this._value._claimPhase = null;
    return this;
  }
}
EventQuestStatus.Builder = EventQuestStatus_Builder;
class EventQuestStatus_WithParent {
  /**
   * @param {EventQuestStatus} value
   * @param {EventQuestStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EventQuestStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasCurrentCount() {
    if (this._cachedHasCurrentCount === undefined) {
      if (this._value.hasCurrentCount) {
        this._cachedHasCurrentCount = true;
      } else {
        this._cachedHasCurrentCount = this._parent ? this._parent.hasCurrentCount : false;
      }
    }
    return this._cachedHasCurrentCount;
  }
  get currentCount() {
    if (this._cachedCurrentCount === undefined) {
      if (this._value.hasCurrentCount) {
        this._cachedCurrentCount = this._value.currentCount;
      } else {
        this._cachedCurrentCount = this._parent ? this._parent.currentCount : this._value.currentCount;
      }
    }
    return this._cachedCurrentCount;
  }
  get hasClaimPhase() {
    if (this._cachedHasClaimPhase === undefined) {
      if (this._value.hasClaimPhase) {
        this._cachedHasClaimPhase = true;
      } else {
        this._cachedHasClaimPhase = this._parent ? this._parent.hasClaimPhase : false;
      }
    }
    return this._cachedHasClaimPhase;
  }
  get claimPhase() {
    if (this._cachedClaimPhase === undefined) {
      if (this._value.hasClaimPhase) {
        this._cachedClaimPhase = this._value.claimPhase;
      } else {
        this._cachedClaimPhase = this._parent ? this._parent.claimPhase : this._value.claimPhase;
      }
    }
    return this._cachedClaimPhase;
  }
  update(current, parent) {
    const result = new EventQuestStatus_WithParent(current, parent);
    return result;
  }
}
EventQuestStatus_WithParent.default = new EventQuestStatus_WithParent(EventQuestStatus.default, null);
EventQuestStatus.WithParent = EventQuestStatus_WithParent;
class EventQuestStatus_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get currentCount() {
    if (!this._currentCount) {
      this._currentCount = {
        name: "currentCount",
        Name: "CurrentCount",
        number: 2,
        protoType: 5,
        protoName: "current_count",
        type: JsonToInt32,
        options: {
          comments: "Player\'s current total event quest progress",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentCount;
  }
  get claimPhase() {
    if (!this._claimPhase) {
      this._claimPhase = {
        name: "claimPhase",
        Name: "ClaimPhase",
        number: 3,
        protoType: 5,
        protoName: "claim_phase",
        type: JsonToInt32,
        options: {
          comments: "Highest phase that player has claimed reward. Default is 0, means no reward claimed",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._claimPhase;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.currentCount,
        this.claimPhase,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentCount",
        Name: "DummyOneofForCurrentCount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClaimPhase",
        Name: "DummyOneofForClaimPhase",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
EventQuestStatus.descriptor = new EventQuestStatus_Descriptor();
